<template>
  <van-popup :value="value" @input="input" round style="width:70%" :get-container="parent">
    <div class="flex flex-col items-center w-full default-padding">
      <div class="title">{{ title }}</div>
      <div class="message" :class="align">{{ message }}</div>
      <div class="flex flex-row items-center  mt-5  w-full gap-3 text-center">
        <div class="left-btn flex-1 radius-border" v-if="showLeft" @click="onLeftClick">{{ leftText }}</div>
        <div class="right-btn flex-1" @click="onRightClick">{{ rightText }}</div>
      </div>
    </div>
  </van-popup>
</template>


<script>
export default {
  name: "DialogTips",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'text-center'
    },
    parent: {
      type:String,
      default: ""
    },
    showLeft: {
      type: Boolean,
      default: true
    },
    showRight: {
      type: Boolean,
      default: true
    },
    leftText: {
      type: String,
      require: true
    },
    rightText: {
      type: String,
      require: true
    },
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    }
  },
  methods: {
    input(e) {
      this.$emit("input", e);
    },
    onLeftClick(e) {
      this.$emit("onLeftClick", e);
    },
    onRightClick(e) {
      this.$emit("onRightClick", e);
    }
  }
};
</script>

<style scoped lang="less">
.title {
  font-size:16px;
  font-weight: bold;
}

.message {
  font-size:14px;
  margin-top: 25px;
}

.left-btn {
  border-color: #BEBEBE;
  color: #333333;
  height: 48px;
  line-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right-btn {
  background: #333333;
  color: white;
  height: 48px;
  line-height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>